// extracted by mini-css-extract-plugin
export default {"image":"F1-z","loaded":"G1-z"};